export default __webpack_public_path__ + "static/media/burn-it-down.023f79c0.gif";